import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { getCookie } from '../../utilities/cookies'

const AccountLogout = () => {
  const formRef = useRef(null)
  const location = useLocation()
  const actionUrl = `/account/logout${location.search || ''}`
  const csrfToken = getCookie('csrftoken')

  useEffect(() => {
    if (formRef.current) {
      formRef.current.submit()
    }
  }, [])

  return (
    <div className="content-block top-spacer transparent-bg">
      <form ref={formRef} method="post" action={actionUrl}>
        {csrfToken && <input type="hidden" name="csrfmiddlewaretoken" value={csrfToken} />}
        <p>Signing you out...</p>
      </form>
    </div>
  )
}

export default AccountLogout
